


























































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Action, Mutation, Getter } from 'vuex-class'
import Route, { nextPage } from '@/routes'
import * as t from '@/types'

@Component
export default class VariableUI extends Vue {
  @Prop() private data!: t.Variable
  @Mutation private setData!: (state: Partial<t.APIData>) => void
  @Getter private getData!: (key: string) => string | null
  @Action private saveData!: () => void
  private currencySymbol = t.currencySymbol
  private frequencies = [ t.Frequency.weekly, t.Frequency.monthly, t.Frequency.annual ]

  getFrequency () {
    return this.getData(this.data.frequency) || t.Frequency.monthly
  }

  setFrequency (value: string) {
    const data: Partial<t.APIData> = {}
    data[this.data.frequency] = value
    return this.setValue(data)
  }

  async setValue ( newData: Partial<t.APIData>) {
    this.setData(newData)
    await this.saveData()
  }

  shouldShowProgressBar () {
    return this.$router.currentRoute.name !== Route.home
  }

  nextPage () {
    return nextPage(this.$router.currentRoute.name as Route)
  }
}
